import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@coolblue-development/freddy';
import { ConditionalWrapper } from '@coolblue-development/next-patterns/client';
const speechBubbleBackgroundColour = {
    user: '#CEE1F3',
    system: 'base',
    error: 'sentimentDangerSubtle',
};
export function SpeechBubble({ children, variant }) {
    const isUser = variant === 'user';
    return (_jsx(Box, { p: 400, backgroundColor: speechBubbleBackgroundColour[variant], flexGrow: 0, sx: theme => ({
            borderRadius: theme.borderRadius[100],
            boxShadow: '0 1px 2px 0 rgb(40 93 171 / 20%)',
        }), children: _jsx(ConditionalWrapper, { condition: isUser, wrapper: children => _jsx(Typography, { whiteSpace: "pre-line", children: children }), children: children }) }));
}
//# sourceMappingURL=SpeechBubble.js.map